<template>
  <div class="auth-container">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AuthContainer'
})
</script>
<style lang="scss" scoped>
// References: https://www.zhangxinxu.com/wordpress/2018/01/css-caret-color-first-line/
@supports (-webkit-mask: none) and (not (cater-color: #000)) {
  .auth-container .el-input {
    input {
      color: #000;
    }
    input::first-line {
      color: #000;
    }
  }
}
.auth-container {
  height: 100%;
  width: 100%;
  width: 520px;
  margin: 0 auto;
  max-width: 100%;
  background-color: #fff;
  padding: 50px 0;

  @media (max-width: 770px) {
    padding-right: 15px;
    padding-left: 15px;
  }
}

:deep(.title-container) {
  :deep(.title) {
    font-size: 26px;
    color: #000;
    margin: 20px auto 40px auto;
    text-align: center;
    font-weight: bold;

    small {
      font-size: 10px;

      &:hover {
        a {
          text-decoration: underline;
        }
      }
    }
  }
}

:deep(.show-pwd) {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  color: #889aa4;
  cursor: pointer;
  user-select: none;
}

:deep(.el-input) {
  display: inline-block;
  height: 47px;
  width: 85%;
  .el-input__wrapper {
    background: transparent;
    box-shadow: none;
    width: 100%;
    border: none;
    &:hover {
      box-shadow: none;
    }
    &:focus {
      box-shadow: none;
    }
    &.is-focus {
      box-shadow: none;
    }
  }
  input {
    height: 47px;
    background: transparent;
    border: 0px;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #000;
    caret-color: #000;
    -webkit-appearance: none;

    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #e5e5e5 inset !important;
      -webkit-text-fill-color: #000 !important;
    }
  }
}

:deep(.el-form-item:not(.checkbox-input)) {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #454545;
}

:deep(.svg-container) {
  padding: 6px 5px 6px 15px;
  color: #889aa4;
  vertical-align: middle;
  width: 30px;
  display: inline-block;
}

/* Dark theme styles */
.dark {
  :deep(.auth-container) {
    background-color: transparent;

    :deep(.title) {
      color: #fff;
    }

    :deep(.el-form-item__label) {
      color: #fff;
    }

    :deep(.el-form-item__content) {
      background: #fff;
      border-radius: 5px;
    }

    :deep(.el-input input:-webkit-autofill) {
      box-shadow: 0 0 0px 1000px #fff inset !important;
    }
  }
}
</style>
